import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 25000 });

export async function fetchLanding(code) {
  const { data } = await client.get(`/landing/${encodeURIComponent(code)}`);
  return data;
}

export async function fetchPrivacy(ref) {
  const { data } = await client.get(`/privacy`, { params: ref ? { ref } : {} });
  return data;
}

export async function submitLead(payload) {
  const { data } = await client.post(`/lead`, payload);
  return data;
}
